<template>
  <div class="row my-4">
    <div
      v-if="data && rowOption === 'table'"
      class="col-sm-12 col-md-5 data-table-rows-per-page"
    >
      <label
        >{{ $t("Rows per Page ")
        }}<select
          :value="sizeperpage"
          name="entries"
          class="form-control mx-1"
          @change="$emit('onchange', $event)"
        >
          <!-- <option value="5">5</option> -->
          <option
            v-for="row in rowOption === 'table'
              ? tableRowsPerPage
              : chartRowsPerPage"
            :key="row"
            :value="row"
          >
            {{ row }}
          </option>
        </select>
      </label>
    </div>
    <div
      v-if="rowOption === 'chart'"
      class="col-sm-12 col-md-6 data-table-rows-per-page"
    >
      <p class="mt-1 mb-0 text-right">
        Page {{ pageNumber }} of {{ pageCount }}
      </p>
    </div>
    <div :class="{
        'col-sm-12 col-md-7': rowOption === 'table',
        'col-sm-12 col-md-6': rowOption === 'chart',
    }">
      <div class="dataTables_paginate paging_simple_numbers">
        <ul
          class="pagination"
          :style="{ justifyContent: rowOption === 'chart' ? 'start' : 'end' }"
        >
          <span
            class="d-flex align-items-center justify-content-center"
            :class="{
              disabled: pageNumber <= 1,
              'cursor-pointer': pageNumber > 1,
            }"
            @click="$emit('prevPage')"
          >
            <PrevIcon />
          </span>

          <li
            class="paginate_button page-item"
            :class="{ active: pageNumber == 1 }"
            @click="$emit('goToFirstPage')"
          >
            <a href="#" class="page-link">1</a>
          </li>

          <!-- <li
            :class="{ disabled: pageNumber <= 1 }"
            class="paginate_button page-item previous"
            @click="$emit('prevPage')"
          >
            <a href="#" class="page-link">{{ $t("prev") }}</a>
          </li> -->

          <li
            class="paginate_button page-item"
            :class="{ active: pageNumber == 2 }"
            v-if="pageCount === 3"
            @click="$emit(customEmitKey, 2)"
          >
            <a href="#" class="page-link">2</a>
          </li>

          <div v-if="pageCount > 3" style="display: inherit; column-gap: 8px">
            <li
              class="paginate_button page-item"
              :class="{ active: pageNumber == page.name }"
              v-for="page in pages"
              :key="page.name"
              @click="$emit(customEmitKey, page.name)"
            >
              <a href="#" class="page-link">{{ page.name }}</a>
            </li>
          </div>

          <!-- <li
            class="paginate_button page-item next"
            :class="{ disabled: pageNumber >= pageCount }"
            @click="$emit('nextPage')"
          >
            <a href="#" class="page-link">{{ $t("next") }}</a>
          </li> -->

          <li
            class="paginate_button page-item"
            :class="{ active: pageNumber == pageCount }"
            v-if="pageCount > 1"
            @click="$emit('goToLastPage')"
          >
            <a href="#" class="page-link">{{ pageCount }}</a>
          </li>

          <span
            class="d-flex align-items-center justify-content-center"
            :class="{
              disabled: pageNumber >= pageCount,
              'cursor-pointer': pageNumber < pageCount,
            }"
            @click="$emit('nextPage')"
          >
            <NextIcon />
          </span>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import PrevIcon from "./Iconsvg/PaginationBack.vue";
import NextIcon from "./Iconsvg/PaginationNext.vue";

export default {
  name: "PaginationNew",
  props: {
    pageCount: Number,
    data: Array,
    sizeperpage: Number,
    pageNumber: Number,
    pages: Array,
    rowOption: {
      type: String,
      default: "table",
    },
    customEmitKey: {
      type: String,
      default: "handlePageChange",
    },
  },
  components: {
    PrevIcon,
    NextIcon,
  },
  data() {
    return {
      tableRowsPerPage: [5, 10, 20, 40, 100],
      chartRowsPerPage: [100, 200, 500, 1000, 2000],
    };
  },
};
</script>

<style></style>
